import * as React from 'react';
import { Team } from '../types';
import { formatScreamingSnakesToPrettyStrings } from '../formatScreamingSnakesToPrettyStrings';
import { Label } from './TaskFilters.styles';
import { StringParam, useQueryParam } from 'use-query-params';

type TeamFilterProps = {
  showAllOption?: boolean;
  handleSelectChange: (value: string, name: string) => void;
};

export const TeamFilter = ({ showAllOption: isBpaView, handleSelectChange }: TeamFilterProps) => {
  const [team] = useQueryParam('team', StringParam);
  return (
    <span key={'teamFilter'}>
      <Label>{isBpaView ? 'Assignment' : 'Team'}</Label>
      <select
        aria-label="team dropdown"
        name="team"
        value={team ?? undefined}
        onChange={({ target: { value, name } }) => handleSelectChange(Team[value], name)}
      >
        {isBpaView && <option value={undefined}>All</option>}
        {Object.values(Team).map(type => (
          <option value={type} key={type}>
            {formatScreamingSnakesToPrettyStrings(type)}
          </option>
        ))}
      </select>
    </span>
  );
};
